import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftHide20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarLeftHide20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 4.5h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-9zM1 5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5zm12.937 2.312a.75.75 0 1 0-1.061-1.06L10.4 9.225l-.53.53.53.53 2.475 2.476a.75.75 0 0 0 1.06-1.061l-1.944-1.945z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftHide20Filled);
